export default "__VITE_ASSET__S0MJ7s2A__"